<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 bg-white shadow-sm rounded-lg border mb-5">
                <form class="m-3" @submit.prevent="submit">
                    <!-- title -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.title }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" maxlength="100" v-model="title" />
                            <span class="text-danger" v-if="errors && errors.title">{{
                                errors.title[0]
                                }}</span>
                        </div>
                    </div>
                    <!-- upload file -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.upload_file }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" value="file" v-model="uploadType"
                                    id="uploadFile" />
                                <label class="form-check-label" for="uploadFile">{{ trans.upload_file }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" value="link" v-model="uploadType"
                                    id="uploadLink" />
                                <label class="form-check-label" for="uploadLink">{{ trans.upload_file_link }}</label>
                            </div>
                            <div class="form-group mt-2 mb-1" v-if="uploadType === 'file'">
                                <input type="file" id="file" @change="handleFileChange" />
                                <div class="text-danger" v-if="errors && errors.file">
                                    {{ errors.file[0] }}
                                </div>
                            </div>
                            <div class="form-group  mt-2 mb-1" v-if="uploadType === 'link'">
                                <input type="text" class="form-control" v-model="linkFile" id="file_url" />
                                <span class="text-danger" v-if="errors && errors.link_file">
                                    {{ errors.link_file[0] }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <!-- line_color -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.line_color }}
                        </label>
                        <div class="col-sm-9">
                            <input type="color" class="form-control form-control-color" v-model="lineColor" style="width: 80px;"/>
                            <span class="text-danger" v-if="errors && errors.line_color">{{
                                errors.line_color[0]
                                }}</span>
                            <small class="form-text text-muted">{{ trans.gtfs_line_color_help }}</small>
                        </div>
                    </div>
                    <!-- show gtfs -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.gtfs.show_gtfs }}
                        </label>
                        <div class="col-sm-9">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" v-model="showGtfs"/>
                            </div>
                        </div>
                    </div>
                    <!-- Map -->
                    <div class="form-group row" v-show="stops.length && shapes.length">
                        <div id="map" style="width: 100%; height: 800px" class="mh-75"></div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.status }}
                        </label>
                        <div class="col-sm-9 mt-2">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="customSwitch1" true-value="1"
                                    false-value="0" v-model="status" />
                                <label class="custom-control-label text-muted" for="customSwitch1">{{
                                    trans.status_val[status] }}</label>
                            </div>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary w-25 center mb-4 mt-4 float-right"
                        :disabled="isDisabled">
                        {{ gtfs ? trans.btn.update : trans.btn.create }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import mapboxgl from 'mapbox-gl';
import MapBox from '../mixins/MapBox/Map';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';

export default {
    mixins: [MapBox],
    props: {
        formAction: {
            type: String,
            required: true
        },
        trans: {
            type: Object,
            required: true
        },
        stops: {
            type: Array,
            default: function () {
                return [];
            },
        },
        shapes: {
            type: Array,
            default: function () {
                return [];
            },
        },
        gtfs: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    data() {
        return {
            title: this.gtfs ? this.gtfs.title : '',
            lineColor: this.gtfs ? this.gtfs.line_color : '#BF93E4',
            errors: {},
            isDisabled: false,
            status: this.gtfs && this.gtfs.status ? 1 : 0,
            linkFile: this.gtfs ? this.gtfs.link_file : '',
            file: null,
            uploadType: this.gtfs && this.gtfs.link_file ? 'link' : 'file',
            showGtfs: this.gtfs ? this.gtfs.show_gtfs : true,
        };
    },
    methods: {
        prepareFormData() {
            let formData = new FormData();
            formData.append('title', this.title);
            formData.append('status', this.status);
            formData.append('link_file', this.linkFile);
            formData.append('line_color', this.lineColor);
            formData.append('show_gtfs', this.showGtfs ? 1 : 0);
            if (this.file instanceof File) {
                formData.append('file', this.file);
            }

            if (this.gtfs) {
                formData.append("_method", "PUT");
            }

            return formData;
        },
        submit() {
            var self = this;
            this.isDisabled = true;

            axios({
                method: 'POST',
                url: this.formAction,
                data: this.prepareFormData(),
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
                .then((response) => {
                    if (response.data.redirectTo != undefined) {
                        window.location.replace(response.data.redirectTo);
                    }
                })
                .catch((error) => {
                    self.isDisabled = false;
                    if (error.response.status == 422) {
                        this.errors = {};
                        this.errors = error.response.data.errors;
                    }
                });
        },
        handleFileChange(event) {
            const file = event.target.files[0];
            this.file = file;
        },
        loadStops() {
            const stopsGeojson = {
                "type": "FeatureCollection",
                "features": this.stops.map(item => {
                    return {
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates": [item.stop_lon, item.stop_lat]
                        },
                        "properties": {
                            "stop_name": item.stop_name,
                            "stop_code": item.stop_code,
                            "stop_desc": item.stop_desc,
                            "route_id": item.route_id,
                            "route_color": item.route_color,
                        }
                    }
                })
            }

            this.mySmartMap.addSource('stops', {
                'type': 'geojson',
                'data': stopsGeojson
            });

            this.mySmartMap.addLayer({
                'id': 'stops',
                'type': 'circle',
                'source': 'stops',
                'paint': {
                    'circle-radius': [
                        'interpolate',
                        ['linear'],
                        ['zoom'],
                        5, 0,
                        10, 0.1,
                        15, 6,
                        18, 10
                    ],
                    'circle-color': '#ffffff',
                    'circle-stroke-width': [
                        'interpolate',
                        ['linear'],
                        ['zoom'],
                        5, 0.2,
                        10, 1,
                        15, 1.2,
                        18, 1.5
                    ],                    
                    'circle-stroke-color': '#3c3c3c'
                }
            });

            this.mySmartMap.on('click', 'stops', (e) => {
                new mapboxgl.Popup()
                    .setLngLat(e.features[0].geometry.coordinates)
                    .setHTML(`
                        <div class="">
                            <div class="bg-base-100 bg-white rounded shadow-xl">
                                <div class="gtfs-popup">
                                    <div class="text-base font-bold mb-2">${e.features[0].properties.stop_name}</div>
                                    <div class="text-sm">
                                        <div class="flex">
                                            <span class="mr-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#${e.features[0].properties.route_color}">
                                                    <path d="M480-280q-73 0-127.5-45.5T284-440H80v-80h204q14-69 68.5-114.5T480-680q73 0 127.5 45.5T676-520h204v80H676q-14 69-68.5 114.5T480-280Zm0-80q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z"></path>
                                                </svg>
                                            </span>
                                            ${e.features[0].properties.route_id}
                                        </div>
                                    <p class="gtfs-popup-route">${e.features[0].properties.stop_desc}</p>
                                </div>
                            </div>
                        </div>
                    `)
                    .addTo(this.mySmartMap);
            });

            this.mySmartMap.on('mouseenter', 'stops', () => {
                this.mySmartMap.getCanvas().style.cursor = 'pointer';
            });

            this.mySmartMap.on('mouseleave', 'stops', () => {
                this.mySmartMap.getCanvas().style.cursor = '';
            });
        },
        loadShapes() {
            for (let i = 0; i < this.shapes.length; i++) {
                const shapes = this.shapes[i];
                const shapesGeojson = {
                    "type": "FeatureCollection",
                    "features": [
                        {
                            "type": "Feature",
                            "geometry": {
                                "type": "LineString",
                                "coordinates": shapes.map(({ shape_pt_lon, shape_pt_lat }) => [shape_pt_lon, shape_pt_lat])
                            },
                            "properties": {
                                "name": "Shapes"
                            }
                        }
                    ]
                };

                this.mySmartMap.addSource('shapes' + i, {
                    'type': 'geojson',
                    'data': shapesGeojson
                });

                this.mySmartMap.addLayer({
                    'id': 'shapes' + i,
                    'type': 'line',
                    'source': 'shapes' + i,
                    'layout': {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },
                    'paint': {
                        'line-color': shapes[0]?.route_color ? '#' + shapes[0]?.route_color : this.lineColor,
                        'line-width': [
                            'interpolate',
                            ['linear'],
                            ['zoom'],
                            5, 0.2,
                            10, 1,
                            15, 2,
                            20, 4
                        ]

                    }
                });
            }
        }
    },
    mounted() {
        this.mySmartMap.on('load', () => {
            this.loadShapes();
            this.loadStops();
        })
    },
};

</script>

<style>
.wrap-text {
    white-space: normal;
    word-wrap: break-word;
}

.gtfs-popup {
    padding: 1rem;
    min-width: 30px;
}

.gtfs-popup-route {
    font-size: 0.9rem;
    margin-bottom: 7px;
}

.mapboxgl-popup-content {
    padding: 0rem !important;
    max-width: 20rem !important;
    min-width: 15rem !important;
    border-radius: 0.75rem !important;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}

.mapboxgl-popup-close-button {
    width: 36px !important;
    height: 36px !important;
    font-size: 24px !important;
    line-height: 36px !important;
    border-radius: 50% !important;
}

.mapboxgl-popup-close-button svg {
    width: 24px !important;
    height: 24px !important;
}
.mapboxgl-popup-close-button:hover {
    background-color: unset;
}
button:focus {
    outline: none;
}
</style>